import Grid from '@/global/components/ui/Grid'
import { CidadesEstado, estadosV2, getCidadesByUf } from '@acme/common'
import { Divider } from '@mui/material'
import axios from 'axios'
import {
    FormField,
    FormFieldAutocomplete,
    FormFieldSelect,
} from 'global/components/Form'
import { ChangeEvent, useLayoutEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { ViaCepApi } from 'types'

export function DadosEndereco() {
    const [cidades, setCidades] = useState<CidadesEstado[]>([])

    const { watch, setValue } = useFormContext()

    const uf = watch('uf')

    function handleChangeCep(event: ChangeEvent<HTMLInputElement>) {
        const cep = event.target.value.replace(/\D/g, '')
        if (cep.length === 8) {
            axios
                .get<ViaCepApi>(`https://viacep.com.br/ws/${cep}/json/`)
                .then(
                    ({
                        data: {
                            logradouro: endereco,
                            localidade: cidade,
                            bairro,
                            uf,
                            ibge,
                        },
                    }) => {
                        if (!watch('uf')) setValue('endereco', endereco)
                        if (!watch('bairro')) setValue('bairro', bairro)
                        if (!watch('uf')) setValue('uf', uf)
                        if (!watch('Cidade'))
                            setValue('Cidade', {
                                cidade,
                                uf,
                                ibge,
                            })
                    },
                )
        }
    }

    useLayoutEffect(() => {
        ;(async () => {
            if (uf !== undefined) {
                const cidades = await getCidadesByUf(uf)
                setCidades(cidades)
            }
        })()
    }, [setValue, uf])

    return (
        <section id="endereco">
            <Divider sx={{ mb: 3, mt: 4, userSelect: 'none' }}>
                Endereço
            </Divider>
            <Grid container spacing={2} columns={24}>
                <Grid item xs={6}>
                    <FormField
                        name="cep"
                        label="CEP"
                        required
                        onChange={handleChangeCep}
                        options={{
                            blocks: [5, 3],
                            delimiter: '-',
                            numericOnly: true,
                        }}
                    />
                </Grid>
                <Grid item xs={4}>
                    <FormFieldSelect
                        name="uf"
                        label="UF"
                        defaultValue={uf}
                        required
                        options={estadosV2.map(({ sigla }) => ({
                            value: sigla,
                            label: sigla,
                        }))}
                    />
                </Grid>
                <Grid item xs={14}>
                    <FormFieldAutocomplete
                        name="Cidade"
                        label="Cidade de trabalho"
                        options={cidades.map(cidade => ({
                            cidade: cidade.nome,
                            uf,
                            ibge: cidade.id,
                        }))}
                        getOptionLabel={option => option.cidade}
                        required
                    />
                </Grid>
                <Grid item xs={8}>
                    <FormField name="bairro" label="Bairro" required />
                </Grid>
                <Grid item xs={11}>
                    <FormField name="endereco" label="Endereço" required />
                </Grid>
                <Grid item xs={5}>
                    <FormField name="numero" label="Número" required />
                </Grid>
            </Grid>
        </section>
    )
}
